import { useEffect, useState } from "react";

export function researchNavigate(path) {
  if (window.location.pathname + window.location.search + window.location.hash !== path) {
    window.history.pushState({}, "", path);
    window.dispatchEvent(new PopStateEvent("popstate"));
  }
  window.scrollTo({ top: 0, behavior: "auto" });
}

export function useResearchLocation() {
  const read = () => window.location.pathname.replace(/\/+$/, "") || "/";
  const [path, setPath] = useState(read);
  useEffect(() => {
    const sync = () => setPath(read());
    window.addEventListener("popstate", sync);
    return () => window.removeEventListener("popstate", sync);
  }, []);
  return path;
}
